(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-page-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.getElementById("bannerSlider");
  const dotsContainer = document.getElementById("bannerDots");

  if (!slider) return;

  const realSlides = Array.from(slider.querySelectorAll(".banner-iteam"));
  const total = realSlides.length;

  if (total === 0) return;

  // Clone first and last for infinite loop
  const firstClone = realSlides[0].cloneNode(true);
  const lastClone = realSlides[total - 1].cloneNode(true);

  slider.appendChild(firstClone);   // clone of first goes at end
  slider.insertBefore(lastClone, realSlides[0]); // clone of last goes at start

  // Start at index 1 (the real first slide)
  let index = 1;
  let isTransitioning = false;

  // Disable transition for silent repositioning
  function setSlide(i, animate) {
    slider.style.transition = animate ? "transform 0.5s ease" : "none";
    slider.style.transform = `translateX(-${i * 100}%)`;
  }

  setSlide(index, false);

  // Create dots (only for real slides)
  realSlides.forEach((_, i) => {
    const dot = document.createElement("span");
    dot.classList.add("banner-dot");
    if (i === 0) dot.classList.add("active");

    dot.addEventListener("click", () => {
      if (isTransitioning) return;
      index = i + 1; // offset by 1 because of prepended clone
      updateDots();
      setSlide(index, true);
    });

    dotsContainer.appendChild(dot);
  });

  function updateDots() {
    const dots = dotsContainer.querySelectorAll(".banner-dot");
    const realIndex = index - 1; // map back to 0-based real index
    dots.forEach((d, i) => d.classList.toggle("active", i === realIndex));
  }

  // After transition ends, silently jump if we're on a clone
  slider.addEventListener("transitionend", () => {
    isTransitioning = false;

    if (index === 0) {
      // We're on the last-clone at the start — jump to real last
      index = total;
      setSlide(index, false);
    }

    if (index === total + 1) {
      // We're on the first-clone at the end — jump to real first
      index = 1;
      setSlide(index, false);
    }

    updateDots();
  });

  function nextSlide() {
    if (isTransitioning) return;
    isTransitioning = true;
    index++;
    setSlide(index, true);
  }

  function prevSlide() {
    if (isTransitioning) return;
    isTransitioning = true;
    index--;
    setSlide(index, true);
  }

  // Auto slide every 4 seconds
  setInterval(nextSlide, 4000);

  // Swipe support
  let startX = 0;

  slider.addEventListener("touchstart", e => {
    startX = e.touches[0].clientX;
  });

  slider.addEventListener("touchend", e => {
    const endX = e.changedTouches[0].clientX;
    if (startX - endX > 50) nextSlide();
    if (endX - startX > 50) prevSlide();
  });
});

  } catch(e) { console.error(e); }
})();
})();
